import _ from "lodash";
import Helper from "../../core/libraries/Helper";
import { checkDatePickerValue, checkDropdownListValue, checkEmptyObject, checkFile, checkLinkValue, checkNotificationPickerValue, checkPeoplePickerValue, checkRadioValue, checkTextInput, checkSPFManagerUploadMode } from "../../core/libraries/Validation";
import { IProperty } from "../AccessMediator/types";
import { Types } from "./actions";
import { IStep, IUpload } from "./types";
import Constants from "../../core/libraries/Constants";
import { IUserProfile } from "../Auth/types";

const initialState: IUpload = {
    steps: [],
    commonReport: {
        UploadType: "",
        RelForForeignTradeLegislation: false,
        SecurityClass: Constants.SECURITY_CLASS_SHORT_NAME.SC1,
        Authors: [],
        NotificationUsers: [],
        AuthorDisplayName: "",
        ExternalAuthorAcknowledged: false
    },
    mode: "user",
    validation: {},
    RnDReportTypes: [],
    ThesisReportTypes: [],
    PaperReportTypes: [],
    rouLists: [],
    changedAuthor: true,
    //checkBoxChecked: false
    SPFManagerList: []
};
type datatype = any;
export const UploadReducer = (state: IUpload = initialState, action: { type: string, data: datatype }) => {
    switch (action.type) {
        case Types.INIT: {
            let result: IUpload = JSON.parse(JSON.stringify(initialState));
            result.steps = [...CommonSteps.map(step => { return { ...step } })];
            result.commonReport = { ...initialState.commonReport };
            result.mode = action.data;
            return result;
        }
        case Types.UPDATE_FIELD: {
            let property: IProperty = action.data;
            let result: IUpload = Object.assign({}, state);
            let commonReport = { ...state.commonReport };
            switch (property.field) {
                case "UploadType": {
                    commonReport[property.field] = property.value;
                    result.steps = [...CommonSteps.map(step => { return { ...step } })];
                    result.rouLists = [];
                    // commonReport.ReportType = null;
                    commonReport.RelForForeignTradeLegislation = false;
                    commonReport.SecurityClass = Constants.SECURITY_CLASS_SHORT_NAME.SC1;
                    commonReport.ROU = "";
                    commonReport.AuthorDisplayName = "";
                    result.changedAuthor = true;
                    commonReport.ExternalAuthorAcknowledged = false;
                    break;
                }
                // case "checkBoxChecked": {
                //     commonReport[property.field] = property.value;
                //     result.changedAuthor = true;
                //     break;
                // }
                case "DocumentType": {
                    commonReport[property.field] = property.value;
                    if (!!state.commonReport.UploadType) {
                        switch (state.commonReport.UploadType) {
                            case Constants.UPLOAD_TYPE.RnD:
                                commonReport['RnDdocumentType'] = property.value;
                                break;
                            case Constants.UPLOAD_TYPE.Thesis:
                                commonReport['ThesisDocumentType'] = property.value;
                                break;
                            case Constants.UPLOAD_TYPE.Paper:
                                commonReport['PaperDocumentType'] = property.value;
                                break;
                            default:
                                break;
                        }
                    }
                    break;
                }
                case "AuthorDisplayName": {
                    commonReport[property.field] = property.value;
                    result.changedAuthor = true;
                    break;
                }
                case "Authors": {
                    commonReport[property.field] = property.value;
                    result.changedAuthor = true;
                    break;
                }
                case "NotificationUsers": {
                    commonReport[property.field] = property.value;
                    break;
                }
                case "RelForForeignTradeLegislation": {
                    commonReport[property.field] = property.value;
                    commonReport.SecurityClass = (!!property.value) ? Constants.SECURITY_CLASS_SHORT_NAME.SC3 : commonReport.SecurityClass;
                    break;
                }
                default: {
                    commonReport[property.field] = property.value;
                    break;
                }
            }
            result.commonReport = commonReport;
            return result;
        }
        case Types.INIT_STEPS: {
            let uploadType = action.data;
            let result: IUpload = Object.assign({}, state);
            switch (uploadType) {
                case "LL": {
                    result.steps = CommonSteps.filter(step => step.label !== "Accessibility");
                    break;
                }
                default: {
                    result.steps = CommonSteps;
                    break;
                }
            }
            let newSteps: any[] = [];
            result.steps.forEach(step => {
                newSteps.push(Object.assign({}, step));
            });
            result.steps = newSteps;
            return result;
        }
        case Types.UPDATE_STEP: {
            let updatedStep: IStep = action.data;
            let result: IUpload = Object.assign({}, state);
            let newSteps: any[] = [];
            result.steps.forEach(step => {
                if (step.label === updatedStep.label) {
                    newSteps.push(Object.assign({}, updatedStep));
                }
                else {
                    newSteps.push({ ...step, isSelected: false });
                }
            });
            result.steps = newSteps;
            return result;

        }
        case Types.VALIDATE_UPLOAD_DATA: {
            let result: IUpload = Object.assign({}, state);
            result.validation = checkTabValidation(state);

            let isValid = false;

            if (checkEmptyObject(result.validation)) {
                isValid = true;
            }

            Helper.runNewTask(() => {
                action.data.callback(isValid);
            });
            return result;
        }

        case Types.SET_DOCUMENT_TYPES: {
            let result: IUpload = Object.assign({}, state);
            (result as any)[action.data.uploadType + "ReportTypes"] = action.data.documentTypes;
            return result;
        }

        case Types.SET_ROU_LIST: {
            let property = action.data;
            let result: IUpload = Object.assign({}, state);
            result.rouLists = property.result;
            let tempROUList = [...result.rouLists]
            // Limit the result if in admin mode
            if (result.mode === "admin") {
                const userProfile = action.data.userProfile as IUserProfile;
                if (userProfile?.permissions?.checkHasPermission([Constants.PERMISSIONS.RND_DIVISION_ADMIN])) {
                    tempROUList = tempROUList.filter(r => r.division === userProfile?.permissions?.checkRnDDivisionAdmin?.divisionCode
                        || r.division === userProfile?.permissions?.checkRnDDivisionAdmin?.divisionTitle);
                }
                if (userProfile?.permissions?.checkHasPermission([Constants.PERMISSIONS.LL_DIVISION_ADMIN])) {
                    tempROUList = tempROUList.filter(r => r.division === userProfile?.permissions?.checkLLDivisionAdmin?.divisionCode
                        || r.division === userProfile?.permissions?.checkLLDivisionAdmin?.divisionTitle);
                }
            }

            // Check fisr loading, get first returned value
            if (result.rouLists.length > 0) {
                result.commonReport.ROU = result.rouLists[0];
                result.commonReport.Division = result.rouLists[0].division;
                result.commonReport.Department = result.rouLists[0].orgName;
            }
            // Check second load, set first result if changing department
            if (action.data.shouldSetFirstValue === true && tempROUList.length > 0) {
                result.commonReport.ROU = tempROUList[0];
                result.commonReport.Division = tempROUList[0].division;
                result.commonReport.Department = tempROUList[0].orgName;
            }
            // Exception for BSH
            const bshROUList = result.rouLists.filter(r => r.division === "BSH");
            if (bshROUList.length > 0 && result.commonReport.UploadType === Constants.UPLOAD_TYPE.LL) {
                result.commonReport.ROU = null;
                result.commonReport.Division = bshROUList[0].division;
                result.commonReport.Department = bshROUList[0].orgName;
            }

            result.changedAuthor = false;
            Helper.runNewTask(() => {
                if (!!action.data.callback) {
                    action.data.callback(result.rouLists);
                }
            });
            return result;
        }

        case Types.SET_GM_LIST: {
            let property = action.data;
            let result: IUpload = Object.assign({}, state);
            result.SPFManagerList = property.result;
            let tempSPFManagerList = [...result.SPFManagerList]
            // Check fisr loading, get first returned value
            let FilteredSPFManagerList = tempSPFManagerList.filter(rou => rou.division === "CR");
            if (FilteredSPFManagerList.length > 0) {
                result.commonReport.SPFManager = FilteredSPFManagerList[0];
                result.commonReport.Division = FilteredSPFManagerList[0].division;
                result.commonReport.Department = FilteredSPFManagerList[0].orgName;
            }
            // Check second load, set first result if changing department
            if (action.data.shouldSetFirstValue === true && tempSPFManagerList.length > 0) {
                result.commonReport.SPFManager = tempSPFManagerList[0];
                result.commonReport.Division = tempSPFManagerList[0].division;
                result.commonReport.Department = tempSPFManagerList[0].orgName;
            }
            result.changedAuthor = false;
            Helper.runNewTask(() => {
                if (!!action.data.callback) {
                    action.data.callback(result.SPFManagerList);
                }
            });
            return result;
        }

        case Types.SET_LL_DIVISION_ADMIN: {
            let result: IUpload = Object.assign({}, state);
            result.commonReport = { ...state.commonReport };
            result.commonReport.LLDivisionAdmin = (!!action.data.result) ? { ...action.data.result } : undefined;
            Helper.runNewTask(() => {
                if (!!action.data.callback) {
                    action.data.callback();
                }
            });
            return result;
        }
        case Types.CALLBACK_UPLOAD_REPORT: {
            Helper.runNewTask(() => {
                if (!!action.data.callback) {
                    action.data.callback(action.data.result);
                }
            });
        }

    }
    return state;
};
export const checkTabValidation = (state: IUpload) => {
    let formValidationResult: any = {};
    switch (state.steps.find(step => step.isSelected === true)?.label) {
        case "Upload": {
            formValidationResult = checkUploadTab(state);
            break;
        }
        case "Properties": {
            formValidationResult = checkPropertiesTab(state);
            break;
        }
        case "Accessibility": {
            formValidationResult = checkAccessibilityTab(state);
            break;
        }
        case "Abstract": {
            formValidationResult = checkAbstractTab(state);
            break;
        }
        case "Release": {
            formValidationResult = checkReleaseTab(state);
            break;
        }

    }
    return formValidationResult;
}
export const checkUploadTab = (state: IUpload) => {
    let result: any = {};
    //Radio button
    result = {
        ...result, ...checkRadioValue({
            value: (state.commonReport.UploadType !== null) ? state.commonReport.UploadType : null,
            fieldName: "UploadType",
            displayName: "uploadtype",
            checkRequired: true,
        })
    };

    if (!!state.commonReport.UploadType) {
        if (state.commonReport.UploadType === "Paper") {
            // Url
            result = {
                ...result, ...checkLinkValue({
                    value: (!!state.commonReport.AttachedUrl) ? state.commonReport.AttachedUrl : null,
                    fieldName: "AttachedUrl",
                    displayName: "url",
                    checkRequired: true,
                })
            };
        }
        else {
            //File
            result = {
                ...result, ...checkFile({
                    value: (!!state.commonReport.Attachment) ? state.commonReport.Attachment.name : "",
                    fieldName: "Attachment",
                    displayName: "attachment",
                    checkRequired: true,
                })
            };
        }
    }
    return result;
}
export const checkPropertiesTab = (state: IUpload) => {
    let result: any = {};
    // Title
    result = {
        ...result, ...checkTextInput({
            value: (!!state.commonReport.Title) ? state.commonReport.Title : null,
            fieldName: "Title",
            displayName: "title",
            checkRequired: true,
            minLength: 4,
            maxLength: 250
        })
    };

    //Authors
    const hasBoschAuthors = !!state.commonReport.Authors && state.commonReport.Authors.length > 0;

    const hasExternalAuthor = !!state.commonReport.AuthorDisplayName && state.commonReport.AuthorDisplayName.trim() !== "";

    result = {
        ...result,
        ...checkPeoplePickerValue({
            condition: hasBoschAuthors || hasExternalAuthor,
            fieldName: "Authors",
            displayName: "authors"
        })
    }

    // AuthorDisplayName
    if (
        state.commonReport.UploadType !== Constants.UPLOAD_TYPE.Paper &&
        state.commonReport.ExternalAuthorAcknowledged
    ) {
        result = {
            ...result, ...checkTextInput({
                value: (!!state.commonReport.AuthorDisplayName) ? state.commonReport.AuthorDisplayName : null,
                fieldName: "AuthorDisplayName",
                displayName: "Author Name",
                checkRequired: true,
                minLength: 4,
                maxLength: 250
            })
        };
    }

    // Report Date
    result = {
        ...result, ...checkDatePickerValue({
            value: (!!state.commonReport.DocumentDate) ? state.commonReport.DocumentDate : null,
            fieldName: "DocumentDate",
            displayName: "report date",
            checkRequired: true,
            checkFutureDate: true
        })
    };
    switch (state.commonReport.UploadType) {
        case "RnD": {
            // Report Type
            result = {
                ...result, ...checkDropdownListValue({
                    condition: !_.isNil(state.commonReport.DocumentType) && state.commonReport.DocumentType !== "",
                    fieldName: "DocumentType",
                    displayName: "report type"
                })
            };


            // Document Number
            result = {
                ...result, ...checkTextInput({
                    value: (!!state.commonReport.DocumentNumber) ? state.commonReport.DocumentNumber : null,
                    fieldName: "DocumentNumber",
                    displayName: "report number",
                    checkRequired: false,
                    maxLength: 250
                })
            };

            // Project Number
            result = {
                ...result, ...checkTextInput({
                    value: (!!state.commonReport.ProjectNumber) ? state.commonReport.ProjectNumber : null,
                    fieldName: "ProjectNumber",
                    displayName: "project number",
                    checkRequired: false,
                    maxLength: 250
                })
            };

            break;
        }
        case "LL": {

            let requiredProcess = true;
            let requiredProduct = true;
            if ((!!state.commonReport.Process)) {
                if (state.commonReport.Process.length !== 0) {
                    requiredProduct = false;
                }

            }
            if ((!!state.commonReport.Product)) {
                if (state.commonReport.Product.length !== 0) {
                    requiredProcess = false;
                }
            }

            //Process
            result = {
                ...result, ...checkTextInput({
                    value: (!!state.commonReport.Process) ? state.commonReport.Process : null,
                    fieldName: "Process",
                    displayName: "process",
                    checkRequired: requiredProcess,
                    maxLength: 250,

                })
            };
            //Product
            result = {
                ...result, ...checkTextInput({
                    value: (!!state.commonReport.Product) ? state.commonReport.Product : null,
                    fieldName: "Product",
                    displayName: "product",
                    checkRequired: requiredProduct,
                    maxLength: 250,

                })
            };
            //Plant/BU
            result = {
                ...result, ...checkTextInput({
                    value: (!!state.commonReport.PlantorBU) ? state.commonReport.PlantorBU : null,
                    fieldName: "PlantorBU",
                    displayName: "Plant/BU",
                    checkRequired: true,
                    maxLength: 250,

                })
            };
            //IQIS number
            result = {
                ...result, ...checkTextInput({
                    value: (!!state.commonReport.IQISNumber) ? state.commonReport.IQISNumber : null,
                    fieldName: "IQISNumber",
                    displayName: "IQISNumber",
                    maxLength: 250,

                })
            };
            break;
        }
        case "Thesis": {
            // Report Type
            result = {
                ...result, ...checkDropdownListValue({
                    condition: !_.isNil(state.commonReport.DocumentType) && state.commonReport.DocumentType !== "",
                    fieldName: "DocumentType",
                    displayName: "report type"
                })
            };
            break;
        }
        case "Paper": {
            // Report Type
            result = {
                ...result, ...checkDropdownListValue({
                    condition: !_.isNil(state.commonReport.DocumentType) && state.commonReport.DocumentType !== "",
                    fieldName: "DocumentType",
                    displayName: "report type"
                })
            };
            if (state.commonReport.DocumentType === "Conference Paper") {

                //Name of conference 
                result = {
                    ...result, ...checkTextInput({
                        value: (!!state.commonReport.NameOfConference) ? state.commonReport.NameOfConference : null,
                        fieldName: "NameOfConference",
                        displayName: "name of conference",
                        checkRequired: true,
                        minLength: 5,
                        maxLength: 250,

                    })
                };

                //Location of conference 
                result = {
                    ...result, ...checkTextInput({
                        value: (!!state.commonReport.LocationOfConference) ? state.commonReport.LocationOfConference : null,
                        fieldName: "LocationOfConference",
                        displayName: "location of conference",
                        checkRequired: true,
                        minLength: 4,
                        maxLength: 250,

                    })
                };
                // Date of conference
                result = {
                    ...result, ...checkDatePickerValue({
                        value: (!!state.commonReport.DateOfConference) ? state.commonReport.DateOfConference : null,
                        fieldName: "DateOfConference",
                        displayName: "date of conference",
                        checkRequired: true,
                    })
                };
            }
            if (state.commonReport.DocumentType === "Journal Paper") {
                //Name of journal 
                result = {
                    ...result, ...checkTextInput({
                        value: (!!state.commonReport.NameOfJournal) ? state.commonReport.NameOfJournal : null,
                        fieldName: "NameOfJournal",
                        displayName: "name of journal",
                        checkRequired: true,
                        minLength: 5,
                        maxLength: 250,

                    })
                };
                // Date of publication
                result = {
                    ...result, ...checkDatePickerValue({
                        value: (!!state.commonReport.DateOfPublication) ? state.commonReport.DateOfPublication : null,
                        fieldName: "DateOfPublication",
                        displayName: "date of publication",
                        checkRequired: true,
                        checkFutureDate: true
                    })
                };
            }
            break;
        }
        default: break;
    }

    return result;
}

export const checkAccessibilityTab = (state: IUpload) => {
    let result: any = {};
    if (state.commonReport.UploadType !== "LL") {
        // Security Class
        result = {
            ...result, ...checkDropdownListValue({
                condition: !_.isNil(state.commonReport.SecurityClass) && state.commonReport.SecurityClass !== "",
                fieldName: "SecurityClass",
                displayName: "security class"
            })
        };
    }
    return result;
}

export const checkAbstractTab = (state: IUpload) => {
    let result: any = {};
    // Keywords     
    result = {
        ...result, ...checkTextInput({
            value: (!!state.commonReport.Keywords) ? state.commonReport.Keywords : null,
            fieldName: "Keywords",
            displayName: "keywords",
            checkRequired: true,
            minLength: 10
        })
    };

    // Abstract
    result = {
        ...result, ...checkTextInput({
            value: (!!state.commonReport.Abstract) ? state.commonReport.Abstract : null,
            fieldName: "Abstract",
            displayName: "abstract",
            checkRequired: true,
        })
    };
    return result;
}

export const checkReleaseTab = (state: IUpload) => {
    let result: any = {};
    const maxUserNotification = 50;
    result = {
        ...result, ...checkDropdownListValue({
            condition: !_.isNil(state.commonReport.ROU) && state.commonReport.managerID !== "",
            fieldName: "ROU",
            displayName: "responsible department"
        })
    };

    //Notifications

    result = {
        ...result, ...checkNotificationPickerValue({
            condition: (state.commonReport.NotificationUsers.length <= maxUserNotification) ? true : false,
            fieldName: "NotificationUsers",
            displayName: "NotificationUsers",
            maxUserNotification: maxUserNotification
        })
    };

    //Strategic Portfolio Owner
    if (state.commonReport.Division === "CR" && state.commonReport.UploadType === "RnD") {
        result = {
            ...result, ...checkSPFManagerUploadMode({
                value: state.commonReport.SPFManager?.managerID,
                fieldName: "SPFManager",
                displayName: "Strategic Portfolio Owner"
            })
        };
    }
    return result;

}

export const CommonSteps: IStep[] = [
    {
        label: "Upload",
        icon: "document-arrow-up",
        valid: true,
        isSelected: true
    },

    {
        label: "Properties",
        icon: "document-add",
        valid: undefined,
        isSelected: false
    },
    {
        label: "Accessibility",
        icon: "document-locked",
        valid: undefined,
        isSelected: false
    },
    {
        label: "Abstract",
        icon: "document-edit",
        valid: undefined,
        isSelected: false
    },
    {
        label: "Release",
        icon: "document-cv",
        valid: undefined,
        isSelected: false
    },
    {
        label: "Summary",
        icon: "document-check",
        valid: undefined,
        isSelected: false
    }
];